import instanceAxios from "./axios.instance" ;
import { BASE_URI } from "~/assets/base";

export const updateLoyalty = async (enseigneId, loyalty) => {
    const response = await instanceAxios.put(`${BASE_URI}enseigne/loyalty/update/${enseigneId}`,
        { loyalty }
    );

    return response;
}